import { GLOBAL_COUNTRY_ISO, GLOBAL_COUNTRY_NAME } from "@stadium/helpers/country/constants";

export const CANADA_ISO = "CA";
export const US_ISO = "US";
export const GLOBAL_ISO = "GL";

export const NON_INTERNATIONAL_COUNTRIES_ISO = [CANADA_ISO, US_ISO];

export const GLOBAL_COUNTRY = Object.freeze({
  name: GLOBAL_COUNTRY_NAME,
  iso: GLOBAL_COUNTRY_ISO,
  label: "global",
  id: "global",
});

export const US_COUNTRY = Object.freeze({
  name: "United States",
  iso: US_ISO,
  label: "US",
});

export const KIT_COUNTRIES_ISO_LIST = [US_ISO, GLOBAL_COUNTRY_ISO];

export const KIT_COUNTRIES = [US_COUNTRY, GLOBAL_COUNTRY];
